import z from '@/lib/zod';
import { optionalSearchString } from './search-param-schemas';

/**
 * Search delle pagine con i soli tab (`subTab`) e ricerca (`search`) nell'URL,
 * così un link o un ricaricamento li conservano: il registro release (su
 * `/admin/releases` e `/referrer/releases`, filtrati sul server) e la lista
 * dei tenant delegati dell'incaricato (filtrata nel browser). Un valore
 * scritto a mano diventa «nessun filtro».
 */
export const tabSearchSchema = z.object({
  subTab: optionalSearchString(),
  search: optionalSearchString(),
});

export type TabSearch = z.output<typeof tabSearchSchema>;
